<template>
  <div
    v-if="currentUser"
    >
    <div
      >
      <v-tabs
        v-model="tab"
        background-color="white"
        >
        <v-tab
          :value="0"
          >
          Mis búsquedas <v-icon color="primary" class="ml-2" v-if="currentUser.selectedAgency.unseenResults">mdi-bell-circle</v-icon>
        </v-tab>

        <v-tab
          :value="1"
          >
          Mis propiedades <v-icon color="primary" class="ml-2" v-if="currentUser.selectedAgency.unseenPropertiesResults">mdi-bell-circle</v-icon>
        </v-tab>
      </v-tabs>
    </div>

    <v-tabs-items 
      v-model="tab">
      <v-tab-item>
        <clients></clients>
      </v-tab-item>

      <v-tab-item>
        <properties></properties>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import Clients from '@/components/matches/Clients'
import Properties from '@/components/matches/Properties'

import { mapGetters } from 'vuex'

export default {
  data: () => ({
    tab: 0
  }),

  components: {
    Clients,
    Properties,
  },

  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>
